/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type numberOfTasksComponent_viewer$ref: FragmentReference;
declare export opaque type numberOfTasksComponent_viewer$fragmentType: numberOfTasksComponent_viewer$ref;
export type numberOfTasksComponent_viewer = {|
  +insightComponentsData: ?{|
    +cardsDone: ?{|
      +numOfCards: ?number,
      +numOfCardsDone: ?number,
    |}
  |},
  +$refType: numberOfTasksComponent_viewer$ref,
|};
export type numberOfTasksComponent_viewer$data = numberOfTasksComponent_viewer;
export type numberOfTasksComponent_viewer$key = {
  +$data?: numberOfTasksComponent_viewer$data,
  +$fragmentRefs: numberOfTasksComponent_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isProjectGroupType",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "numberOfTasksComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isProjectGroupType",
              "variableName": "isProjectGroupType"
            },
            {
              "kind": "Variable",
              "name": "projectId",
              "variableName": "projectId"
            }
          ],
          "concreteType": "CardsDone",
          "kind": "LinkedField",
          "name": "cardsDone",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numOfCards",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numOfCardsDone",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '94a97f73fad8bc9e367cbd6d373beaa5';

module.exports = node;
